/*
 *   File : delete-ams.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description : Delete AMS confirmation modal
 *   Integrations : null
 *   Version : v1.0
 *   Created : 06-05-2026
 */

/* import packages */
import React, { useEffect, useState } from "react";
import $ from "jquery";

/* import styles */
import modalStyle from "../../styles/components/confirmation.module.scss";
import styles from "../../styles/components/manageAMS.module.scss";

/* import components */
import { Toast } from "../note";

/* import assets */
import Delete from "../../assets/images/modal/delete.svg";

const MODAL_ID = "deleteAMS";

export default function DeleteAMS(props) {

    const [loader, setLoader] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        const modalEl = document.getElementById(MODAL_ID);
        if (!modalEl) return;
        const handler = () => {
            setLoader(false);
            setError(null);
            $(".modal-backdrop").remove();
            $("body").removeAttr("style");
            if (props.closeModal) props.closeModal();
        };
        modalEl.addEventListener("hidden.bs.modal", handler);
        return () => modalEl.removeEventListener("hidden.bs.modal", handler);
    }, [props]);

    useEffect(() => {
        if (error !== null) {
            const t = setTimeout(() => setError(null), 3000);
            return () => clearTimeout(t);
        }
    }, [error]);

    const _handleDelete = () => {
        setLoader(true);
        Promise.resolve(props.onConfirm && props.onConfirm(props.data))
            .finally(() => setLoader(false));
    };

    return (
        <div className={`${modalStyle.e_confirmation} modal fade`}
            id={MODAL_ID}
            tabIndex="-1"
            data-bs-backdrop="static"
            aria-labelledby="deleteAMS"
            aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button"
                            className="btn-close"
                            id="ams-delete-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            disabled={loader} />
                        <button type="button"
                            className="d-none"
                            id="ams-delete-dismiss"
                            data-bs-dismiss="modal"
                            aria-label="Close" />
                    </div>
                    <div className="container px-3 pb-3">
                        <div className="row">
                            <div className="col-12 text-center">
                                <img src={Delete} alt="" />
                            </div>
                            <div className="col-12 text-center">
                                <p className="mt-3">Are you sure want to remove the AMS</p>
                            </div>
                        </div>
                        <div className="row pt-2 pb-2">
                            <div className="col-12 d-flex justify-content-center gap-3">
                                <button type="button"
                                    className={`${styles.e_delete_confirm} ${loader ? "e-btn-loader" : ""}`}
                                    disabled={loader}
                                    onClick={_handleDelete}>
                                    Delete
                                </button>
                                <button type="button"
                                    className={styles.e_delete_cancel}
                                    data-bs-dismiss="modal"
                                    disabled={loader}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {error !== null ? <Toast data={error} type="fail" id="ams-delete-error" /> : null}
        </div>
    );
}
